import manifestJson from '../../content/manifest.json'

/**
 * Static content manifest.
 *
 * The offline generation pipeline writes `content/manifest.json` into the
 * repository; the browser only ever *reads* it, imported at build time (no
 * runtime API). The manifest is versioned so the loader can refuse an
 * incompatible content shape rather than mis-render it.
 */

export interface LessonSummary {
  id: string
  title: string
  /** One-line description shown in Journey and Library. */
  summary: string
  estimatedMinutes: number
  /**
   * Markdown filename under `content/lessons/`. Absent for lessons that are in
   * the curriculum but not yet published (shown as upcoming, not startable).
   */
  file?: string
}

export interface ContentManifest {
  version: number
  /** Human-readable name of the active learning path. */
  path: string
  lessons: LessonSummary[]
}

export const CONTENT_MANIFEST_VERSION = 1

export const contentManifest: ContentManifest = validateManifest(manifestJson)

function validateManifest(raw: unknown): ContentManifest {
  if (
    typeof raw !== 'object' ||
    raw === null ||
    (raw as { version?: unknown }).version !== CONTENT_MANIFEST_VERSION
  ) {
    throw new Error(
      `Unsupported content manifest version (expected ${CONTENT_MANIFEST_VERSION}). ` +
        'Regenerate content/manifest.json for this app version.',
    )
  }
  return raw as ContentManifest
}

export function findLesson(id: string): LessonSummary | undefined {
  return contentManifest.lessons.find((lesson) => lesson.id === id)
}
